import { PageContainer, PageHeader, PaginationButtons, TableBodyContainer, TableBodyLine, TableContainer, TableHeader } from '@touche-lts/panel-ui/dist'
import { IconAgreements } from 'assets/icons'
import { LegalStatuses, LegalTableSortProps } from 'mobx-stores/legal/legal-table/legal-table-store.types'
import { useRootStore } from 'mobx-stores/store-provider'
import { LegalTableEntityDTO } from 'models/legal-table-entry'
import { useEffect } from 'react'
import DOMPurify from 'dompurify'
import styles from './legal-table.module.scss'
import { observer } from 'mobx-react-lite'
import { useGetScrollWidth } from 'hooks/custom-hooks'

const LegalTablePageComponent = () => {
  const {
    legalTableStore: {
      triggerSearch,
      searchResults,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      paginationInfo,
      statusPublished
    },
    routingStore: { push },
  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const {scrollX,handleScroll} = useGetScrollWidth();

  const legalTableCellWidth = {
    TITLE : 704,
    DATE: 200,
    PUBLISHED: 200,
    CONTENT: 704
  }

  return (
    <PageContainer>
      <PageHeader
        navSegments={[
          {
            icon: IconAgreements,
            label: 'Legal pages',
            iconProps: { viewBox: '0 0 22 22' }
          }
        ]}
        buttons={[
          {
            preset: 'primary',
            children: 'Add a page',
            onClick: () => push('/legal/editor')
          }
        ]}
      />
      {!!searchResults.length && (
        <TableContainer style={{overflowX: 'auto'}} className={styles.thinScroll} onScroll={handleScroll}>
          <TableHeader
            tableColumns={[
              {
                label: 'title',
                // widthPercentage: 100,
                widthPx: legalTableCellWidth.TITLE,
                isColumnMarked: isColumnMarked(LegalTableSortProps.TITLE),
                sortDirection: getSortDirection(LegalTableSortProps.TITLE),
                setSortDirection: handleSortDirectionChange(
                  LegalTableSortProps.TITLE
                ),
                inputProps: {
                  placeholder: 'Search...',
                  value: searchProps.title,
                  onChange: title => onSearchPropsChange({ title })
                }
              },
              {
                label: 'date added',
                // widthPercentage: 100,
                widthPx: legalTableCellWidth.DATE,
                isColumnMarked: isColumnMarked(LegalTableSortProps.DATE),
                sortDirection: getSortDirection(LegalTableSortProps.DATE),
                setSortDirection: handleSortDirectionChange(
                  LegalTableSortProps.DATE
                ),
                periodFilterProps: {
                  period: searchProps.createdDate,
                  setPeriod: createdDate => onSearchPropsChange({ createdDate }),
                  className: styles.periodFilter
                }
              },
              {
                label: 'published',
                // widthPercentage: 100,
                widthPx: legalTableCellWidth.PUBLISHED,
                selectProps: {
                  noneLabel: 'All',
                  options: statusPublished,
                  value: searchProps.status,
                  onChange: status => onSearchPropsChange({ status })
                },
                isColumnMarked: isColumnMarked(LegalTableSortProps.PUBLISHED),
                sortDirection: getSortDirection(LegalTableSortProps.PUBLISHED),
                setSortDirection: handleSortDirectionChange(
                  LegalTableSortProps.PUBLISHED
                )
              },
              {
                label: 'content',
                // widthPercentage: legalTableCellWidth.CONTENT,
                widthPx: legalTableCellWidth.CONTENT,
                isColumnMarked: isColumnMarked(LegalTableSortProps.CONTENT),
                sortDirection: getSortDirection(LegalTableSortProps.CONTENT),
                setSortDirection: handleSortDirectionChange(
                  LegalTableSortProps.CONTENT
                )
              }
            ]}
          />
          <TableBodyContainer className={styles.tableBodyContainer}>
            {searchResults.map((legal: LegalTableEntityDTO) => {
              return (
                <TableBodyLine
                  key={legal.id}
                  onClick={() => push('/legal/editor/' + legal?.id)}
                  style={{cursor: 'pointer'}}
                  cells={[
                    {
                      // widthPercentage: 100,
                      widthPx: legalTableCellWidth.TITLE,
                      children: <span style={{fontWeight: 800}}>{legal?.title}</span>
                    },
                    {
                      // widthPercentage: 100,
                      widthPx: legalTableCellWidth.DATE,
                      children: <span>{new Date(legal?.createdDate).toLocaleDateString()}</span>
                    },
                    {
                      // widthPercentage: 100,
                      widthPx: legalTableCellWidth.PUBLISHED,
                      children: <span className={styles.status}>{legal?.status === LegalStatuses.ACTIVE ? 'Yes' : 'No'}</span>
                    },
                    {
                      // widthPercentage: 100,
                      widthPx: legalTableCellWidth.CONTENT,
                      children: <span className={styles.content} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(legal?.content || '')}}></span>
                    }
                  ]}
                  className={styles.tableBodyLine}
                />
              )
            })}
          </TableBodyContainer>
          <PaginationButtons alwaysShow {...paginationInfo} style={{width : scrollX}} />
        </TableContainer>
      )}
      {!searchResults.length && (
        <p className={styles.noLetgalTex}>Create your fist legal page now!</p>
      )}
    </PageContainer>
  )
}

const LegalTablePage = observer(LegalTablePageComponent)
export { LegalTablePage }
